<div class="container-fluid">
    <div class="d-flex justify-content-between align-items-center mb-4">
        <h4 id="upper">TEP/PAI</h4>

    </div>
    <div class="d-flex justify-content-end">
        <!-- Bouton Exporter -->
        <div class="me-3">
            <label class="d-inline-flex align-items-center">
                Début:
                <input type="date" [(ngModel)]="dateDebut" class="form-control ms-2" name="dateDebut">
            </label>
        </div>

        <div class="me-3">
            <label class="d-inline-flex align-items-center">
                Fin:
                <input type="date" [(ngModel)]="dateFin" class="form-control ms-2" name="dateFin">
            </label>
        </div>
        <div class="me-3">
            <div id="tickets-table_filter" class="dataTables_filter">
                <input (click)="getStatistique()" type="button" value="Rechercher" class="btn btn-primary">
            </div>
        </div>

        <div class="me-3">
            <button routerLink="/suivi/edition/pai-stats" type="button" class="btn btn-secondary">PAI</button>
        </div>

        <div class="me-3">
            <button (click)="exportPaiDetail()" type="button" class="btn btn-primary">
                <i class="pi pi-file-pdf" style="font-size: 0.8rem"></i> PAI détail
            </button>
        </div>

        <div class="dropdown d-inline-block mb-2 me-2" ngbDropdown>
            <button type="button" ngbDropdownToggle class="btn btn-secondary dropdown-toggle" id="dropdownMenuButton"
                aria-haspopup="true" aria-expanded="false">
                Exporter <i class="pi pi-upload" style="font-size: 0.8rem"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('pdf')">Au format PDF</a>
                <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('excel')">Au format
                    Excel</a>
            </div>
        </div>

        <!-- <div>
            <button routerLink="/suivi/edition/pai" type="button" class="btn btn-primary me-2">
                <i class="pi pi-arrow-left" style="font-size: 0.8rem"></i> Retour
            </button>
        </div> -->

    </div>
    <div class="row">

        <!-- Main Content -->
        <div class="col-md-12 p-0">
            <!-- Tableau des activités par année -->
            <div class="card">
                <div class="table-responsive">
                    <table class="table table-bordered mb-0 tep-table">
                        <thead class="thead-light rwd-table">
                            <tr>
                                <th style="width:150px">Code</th>
                                <th>Libellé</th>
                                <th>Amputation budgétaire</th>
                                <th class="text-center" style="width:70px">Poids</th>
                                <th class="text-end" style="width:150px">Montant (FCFA)</th>
                                <!-- Colonne FADEC SUPPRIMÉE -->
                                <th class="text-center" style="width:90px">TEP Prévu</th>
                                <th class="text-center" style="width:90px">TEP Réalisé</th>
                                <th class="text-center" style="width:110px">Taux</th>
                                <th class="text-center" style="width:130px">Période</th>
                                <th style="width:110px">Responsable</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let bloc of items">

                                <!-- ═══════════════ PROGRAMME ═══════════════ -->
                                <tr class="row-programme" style="cursor:pointer"
                                    (click)="toggleProgramme(bloc.programme.id)">
                                    <td>
                                        <i class="pi me-2 chevron"
                                            [class.pi-chevron-down]="isProgrammeOpen(bloc.programme.id)"
                                            [class.pi-chevron-right]="!isProgrammeOpen(bloc.programme.id)"></i>
                                        <span class="badge bg-dark fs-6">{{ bloc.programme.code }}</span>
                                    </td>
                                    <td class="fw-bold text-uppercase">{{ bloc.programme.libelle }}</td>
                                    <td class="text-center">-</td>
                                    <td class="text-center">
                                        <span class="badge bg-light text-dark border">{{ bloc.programme.poids }}</span>
                                    </td>
                                    <td class="text-end montant">{{ bloc.programme.cout | formatMoney:null }}</td>
                                    <!-- FADEC SUPPRIMÉ -->
                                    <td class="text-center">
                                        <span class="badge bg-info text-dark">{{ bloc.tep_prevu | number:'1.2-2' }}</span>
                                    </td>
                                    <td class="text-center">
                                        <span class="badge bg-success">
                                            {{ bloc.tep_realise | number:'1.2-2' }}
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <ng-container
                                            *ngTemplateOutlet="tauxBadge; context:{taux: getTaux(bloc.tep_prevu, bloc.tep_realise)}"></ng-container>
                                    </td>
                                    <td class="text-center small text-white-50">—</td>
                                    <td class="small">{{ bloc.programme.responsable_programme | slice:0:20 }}</td>
                                </tr>

                                <!-- ═══════════════ ACTIONS ═══════════════ -->
                                <ng-container *ngIf="isProgrammeOpen(bloc.programme.id)">
                                    <ng-container *ngFor="let actionBloc of bloc.actions">

                                        <tr class="row-action" style="cursor:pointer"
                                            (click)="toggleAction(actionBloc.action.id)">
                                            <td class="ps-3">
                                                <i class="pi me-1 chevron text-primary"
                                                    [class.pi-chevron-down]="isActionOpen(actionBloc.action.id)"
                                                    [class.pi-chevron-right]="!isActionOpen(actionBloc.action.id)"></i>
                                                <span class="badge bg-primary">{{ actionBloc.action.code }}</span>
                                            </td>
                                            <td class="fw-semibold">{{ actionBloc.action.libelle }}</td>
                                            <td class="text-end">—</td>
                                            <td class="text-center">
                                                <span class="badge bg-light text-dark border">{{ actionBloc.action.poids
                                                    }}</span>
                                            </td>
                                            <td class="text-end montant">{{ actionBloc.action.montant | formatMoney:null
                                                }}</td>
                                            <!-- FADEC SUPPRIMÉ -->
                                            <td class="text-center">
                                                <span class="badge bg-info text-dark">{{ actionBloc.tep_prevu | number:'1.2-2' }}</span>
                                            </td>
                                            <td class="text-center">
                                                <span class="badge bg-success">{{ actionBloc.tep_realise | number:'1.2-2' }}</span>
                                            </td>
                                            <td class="text-center">
                                                <ng-container
                                                    *ngTemplateOutlet="tauxBadge; context:{taux: getTaux(actionBloc.tep_prevu, actionBloc.tep_realise)}"></ng-container>
                                            </td>
                                            <td class="text-center small">
                                                {{ actionBloc.action.date_debut | date:'dd/MM/yy' }} →<br>
                                                {{ actionBloc.action.date_fin | date:'dd/MM/yy' }}
                                            </td>
                                            <td class="small">—</td>
                                        </tr>

                                        <!-- ═══════════════ ACTIVITES ═══════════════ -->
                                        <ng-container *ngIf="isActionOpen(actionBloc.action.id)">
                                            <tr *ngFor="let activiteBloc of actionBloc.activites" class="row-activite">
                                                <td class="ps-5">
                                                    <span class="badge bg-success">{{
                                                        activiteBloc.activite.code_activite
                                                        }}</span>
                                                </td>
                                                <td class="ps-2 small">
                                                    <i class="pi pi-angle-double-right text-success me-1"></i>
                                                    {{ activiteBloc.activite.activite }}
                                                </td>
                                                <td class="text-center ps-2 small">
                                                    {{ activiteBloc.activite.amputation_budgetaire | formatMoney:null ||
                                                    '-' }}
                                                </td>
                                                <td class="text-center">
                                                    <span class="badge bg-warning text-dark">{{
                                                        activiteBloc.activite.poids
                                                        }}</span>
                                                </td>
                                                <td class="text-end montant">{{ activiteBloc.activite.total |
                                                    formatMoney:null }}</td>
                                                <!-- FADEC SUPPRIMÉ -->
                                                <td class="text-center">
                                                    <span class="badge bg-info text-dark">{{
                                                        activiteBloc.tep_prevu | number:'1.2-2'
                                                        }}</span>
                                                </td>
                                                <td class="text-center">
                                                    <span class="badge bg-success">{{ activiteBloc.tep_realise | number:'1.2-2'
                                                        }}</span>
                                                </td>
                                                <td class="text-center">
                                                    <ng-container
                                                        *ngTemplateOutlet="tauxBadge; context:{taux: getTaux(activiteBloc.activite.tep_prevu, activiteBloc.activite.tep_realise)}"></ng-container>
                                                </td>
                                                <td class="text-center small text-muted">
                                                    {{ activiteBloc.activite.date_debut | date:'dd/MM/yy' }} →<br>
                                                    {{ activiteBloc.activite.date_fin | date:'dd/MM/yy' }}
                                                </td>
                                                <td>
                                                    <span class="badge bg-light text-dark border small">
                                                        {{ activiteBloc.activite.structure_responsable }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </ng-container>

                                    </ng-container>
                                </ng-container>

                            </ng-container>
                        </tbody>
                    </table>
                </div>

                <!-- Aucune donnée -->
                <div *ngIf="items.length === 0" class="text-center py-5 text-muted">
                    <i class="pi pi-inbox" style="font-size:2rem"></i>
                    <p class="mt-2">Aucune donnée. Veuillez lancer une recherche.</p>
                </div>
            </div>

        </div>
    </div>
</div>

<ng-template #tauxBadge let-taux="taux">
    <span class="badge" [class.bg-success]="taux >= 90" [class.bg-warning]="taux >= 60 && taux < 90"
        [class.bg-danger]="taux < 60">
        {{ taux }}%
    </span>
</ng-template>
<p-toast />
<ngx-ui-loader></ngx-ui-loader>